import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"file-zip"} maskId="square-filled-radius-0-stroke-1-IconFileZip"><path fillRule="evenodd" clipRule="evenodd" d="M13 2L13 9H20V22H4V2H13ZM9 12H8V13.5H9L9 15H8L8 16.5H9L9 18H8V19.5H9V21H10V19.5H9L9 18H10L10 16.5H9L9 15L10 15L10 13.5H9V12Z" fill="currentColor"/><path d="M14 2.04289L14 8H19.9571L14 2.04289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFileZip;
